import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import styles from './glossaryNav.module.scss';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function GlossaryNav({ nav = [] }) {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (width < 1280) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);
  return (
    <nav className={`${isMobile ? styles.mobileNav : styles.desktopNav}`}>
      {nav.map((item, index) => {
        const key = `item-${index}`;
        return item.isEnabled ? (
          <Link
            key={key}
            href={item.link}
            className={`${styles.navLink} ${
              item.isActive ? styles.active : ''
            }`}
          >
            {item.label}
          </Link>
        ) : (
          <span key={key} className={`${styles.navLink} ${styles.disabled}`}>
            {item.label}
          </span>
        );
      })}
    </nav>
  );
}

GlossaryNav.propTypes = {
  nav: PropTypes.array,
};
